export default {
      id: "i-trash-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-trash",
      toString: function () {
        return this.url;
      }
    }